import React from 'react';

function Footer() {
  return (
    <footer className="py-3 px-4 border-top bg-white text-center">
      <small style={{ color: '#8a94ad', fontSize: '0.75rem' }}>
        2025 &copy; Skillengine Inc. &mdash; NekotoWan Admin
      </small>
    </footer>
  );
}

export default Footer;
